'''<template>
  <div class="container mt-5">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="card text-center">
          <div class="card-body">
            <img src="@/assets/logo.png" alt="Logo" class="mb-4" style="width: 150px;" />
            <div v-if="!claimedAccount.email">
              <h2 class="card-title">Claim Your Account</h2>
              <p class="card-text">for session: <strong>{{ sessionName }}</strong></p>
              <p class="card-text">Click the button below to claim your account for this session.</p>
              <button @click="claimAccount" class="btn btn-primary" :disabled="loading">
                <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                {{ loading ? ' Claiming...' : 'Claim My Account' }}
              </button>
              <div v-if="error" class="alert alert-danger mt-3" role="alert">
                {{ error }}
              </div>
            </div>
            <div v-if="claimedAccount.email">
              <h2 class="card-title">Your Account Details</h2>
              <div class="input-group mb-3">
                <input type="text" class="form-control" :value="claimedAccount.email" readonly>
                <button class="btn btn-outline-secondary" @click="copyToClipboard(claimedAccount.email, 'username')">
                  <i :class="usernameIcon"></i>
                </button>
              </div>
              <div class="input-group mb-3">
                <input type="text" class="form-control" value="gogoogle1" readonly>
                <button class="btn btn-outline-secondary" @click="copyToClipboard('gogoogle1', 'password')">
                  <i :class="passwordIcon"></i>
                </button>
              </div>
              <p class="card-text">Please save these details. You can now log in.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';

export default {
  setup() {
    const route = useRoute();
    const loading = ref(false);
    const error = ref(null);
    const claimedAccount = ref({});
    const usernameCopied = ref(false);
    const passwordCopied = ref(false);

    const sessionName = route.params.sessionName;

    const usernameIcon = computed(() => usernameCopied.value ? 'bi bi-clipboard-check-fill' : 'bi bi-clipboard');
    const passwordIcon = computed(() => passwordCopied.value ? 'bi bi-clipboard-check-fill' : 'bi bi-clipboard');

    onMounted(() => {
      const storedAccount = localStorage.getItem(`claimedAccount_${sessionName}`);
      if (storedAccount) {
        claimedAccount.value = JSON.parse(storedAccount);
      }
    });

    const claimAccount = async () => {
      loading.value = true;
      error.value = null;

      try {
        const response = await fetch(`https://us-central1-demotool-e1a5e.cloudfunctions.net/claimAccount?sessionName=${sessionName}`);
        const data = await response.json();

        if (response.ok) {
          claimedAccount.value = data;
          localStorage.setItem(`claimedAccount_${sessionName}`, JSON.stringify(data));
        } else {
          error.value = data.error || 'An error occurred.';
        }
      } catch (e) {
        error.value = 'Failed to connect to the server.';
      }

      loading.value = false;
    };

    const copyToClipboard = (text, type) => {
      navigator.clipboard.writeText(text);
      if (type === 'username') {
        usernameCopied.value = true;
        setTimeout(() => (usernameCopied.value = false), 2000);
      } else if (type === 'password') {
        passwordCopied.value = true;
        setTimeout(() => (passwordCopied.value = false), 2000);
      }
    };

    return {
      loading,
      error,
      claimedAccount,
      claimAccount,
      sessionName,
      copyToClipboard,
      usernameIcon,
      passwordIcon,
    };
  },
};
</script>'''